import React, { Component, createRef } from "react";
import { withRouter, Link } from "react-router-dom";
import { Form } from "react-form";
import { connect } from "react-redux";

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import MTextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as authActions from "./actions";
import { Permission } from "../page/models";

import * as navActions from "../common/actions";


// import Submit from "../common/Submit";
import Submit from "../common/commonAccessability/accessabilitySubmit";



// import TextField from "../common/TextField";
import AccTextField from "../common/commonAccessability/accessabilityTextField";


const styles = {
    loginError: {
        color: "red",
        textAlign: "center",
    },
    marginBottomButton: {
        marginBottom: 24,
    },
    linkColor: {
        float: "right",
        marginTop: 16,
    },
    minWidth: {
        width: 350,
    },
};


const getdashboardPermissions = Permission.selectAll();

class LoginPage extends Component {
    state = {
        mfaDialogOpen: false,
        mfaCode: "",
        mfaSubmitFunction: null,
        mfaLoading: false,
    };
    codeInputRef = createRef();

    logOut = () => {
        const { authState, history } = this.props;
        
        this.props.authLogout(authState, history);
    };

    continueDashboard = () => {
      
        if (this.props.authState.user.default_dashboard) this.props.history.push("/dashboard/" + this.props.authState.user.default_dashboard);
        else this.props.history.push("/dashboard");
    };

    errorValidator = (values) => {
        const validateUsername = (value) => {
            return !value ? "Username is required." : null;
        };
        const validatePassword = (value) => {
            return !value ? "Password is required." : null;
        };
        return {
            username: validateUsername(values.username),
            password: validatePassword(values.password),
        };
    };

    loginSubmit = (values, e, formApi) => {
        const { history } = this.props;
        this.props.authLogin(values, history).then((mfaSubmit) => {
            const { authState } = this.props;

            if (authState.error) {
                formApi.setValue("password", "");
            }
            else if (authState.mfa?.isPending && typeof mfaSubmit === "function") {
                this.setState({
                    mfaDialogOpen: true,
                    mfaSubmitFunction: mfaSubmit
                });
            }
            else if (authState.user) {
                this.handleRedirect();
            }
        });
    };

    handleMfaSubmit = async () => {
        const { mfaSubmitFunction, mfaCode } = this.state;
        this.setState({ mfaLoading: true });

        try {
            await mfaSubmitFunction(mfaCode); // call the function returned by authLogin
            this.setState({ mfaDialogOpen: false, mfaCode: "", mfaSubmitFunction: null, mfaLoading: false });
            this.handleRedirect(this.props.authState.user);
        } catch (err) {
            alert("Invalid Mutli Factor Authentication code. Please try again.");
            this.setState({ mfaCode: "", mfaLoading: false });
            this.codeInputRef.current.focus();
        }
    };

    handleRedirect = () => {
        const { authState } = this.props;

        this.props.setMapSettings({
            lat: null,
            lng: null,
            zoom: null,
        });
 
        if (authState.user.oauth_account) { 
            this.props.setOauthCity(authState.user.city_id, authState.user.oauth_url);
        }else{
            this.props.setOauthCity(false, null);//clear state when not oauth--for jumping between cities
        }

        if (authState.user.redirect) {
            this.props.history.push(authState.user.redirect.replace("#", "") + "?old=True");
        } else if (this.props.location.search) {
            this.props.history.push(this.props.location.search.replace("?return=", ""));
        } else {
            if (authState.user.default_dashboard) {
                if (authState.user.city_id === 32){
                    this.props.history.push("/page/249/798/table"); // LA direct route
                }else if (authState.user.city_id === 14 && authState.user.default_dashboard === "51"){
                    this.props.history.push("/page/51/332/table"); // Ninemile permit direct route to table
                }else
                    this.props.history.push("/dashboard/" + authState.user.default_dashboard);
            } else {
                if (authState.user.city_id === 32)
                    this.props.history.push("/page/249/798/table");
                else
                    this.props.history.push("/dashboard");
            }
        }
    };

    render() {
        const { classes, authState } = this.props;
        const { mfaLoading } = this.state;

        if (!authState) return "...";
        return authState.user ? (
            <div>
                <Typography
                    variant="h6"
                    gutterBottom={true}
                >
                    Welcome, {authState.user.name}
                </Typography>

                <Button
                    onClick={this.continueDashboard}
                    variant="contained"
                    color="primary"
                    fullWidth
                    className={classes.marginBottomButton}
                >
                    Continue to Dashboard
                </Button>
                <Button
                    onClick={this.logOut}
                    fullWidth
                >
                    Logout
                </Button>
            </div>
        ) : (
            <>
                <Form
                    dontValidateOnMount="true"
                    validateOnSubmit="true"
                    validateError={this.errorValidator}
                    onSubmit={this.loginSubmit}
                >
                    {(formApi) => (
                        <form onSubmit={formApi.submitForm}>
                            <Typography
                                // variant="h6"
                                gutterBottom
                                variant="h2"
                                style={{
                                    fontSize: "1.5rem",
                                    fontWeight: 400,
                                    lineHeight: 1.6,
                                }}
                            >
                                Existing Users
                            </Typography>

                            <Grid
                                container
                                spacing={2}
                            >

                                <Grid item xs={12}>
                                    <AccTextField
                                        field="username"
                                        label="Username"
                                        fullWidth
                                    />
                                </Grid>


                                <Grid item xs={12}>
                                    <AccTextField
                                        field="password"
                                        label="Password"
                                        type="password"
                                        fullWidth
                                    />
                                </Grid>

                            </Grid>


                            <Typography className={classes.loginError} gutterBottom>
                                {authState.error}
                            </Typography>


                            <Submit
                                variant="raised"
                                label="Login"
                                gridSize={24}
                                loading={authState.pending}
                            />


                            <Button component={Link} className={classes.linkColor} to="/password/reset">
                                Forgot your password?
                            </Button>
                        </form>
                    )}
                </Form>

                <Dialog
                    open={this.state.mfaDialogOpen}
                    classes={{ paper: classes.minWidth }}
                    onClose={() => this.setState({ mfaDialogOpen: false })}
                >
                    <DialogTitle>Multi Factor Authentication</DialogTitle>
                    <DialogContent>
                        <Typography style={{ textAlign: "center" }} gutterBottom>Please use your selected authorization app to generate a token code and enter it below.</Typography>
                        <MTextField
                            autoFocus
                            margin="dense"
                            label="Code"
                            type="text"
                            value={this.state.mfaCode}
                            inputProps={{ maxLength: 6 }}
                            onChange={(e) => this.setState({ mfaCode: e.target.value })}
                            inputRef={this.codeInputRef}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    this.handleMfaSubmit();
                                }
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Grid container alignItems="center">

                            <Grid item xs={6}>
                                <Button
                                    onClick={() => this.setState({ mfaDialogOpen: false })}
                                >
                                    Cancel
                                </Button>
                            </Grid>

                            <Grid
                                item
                                xs={6}
                                style={{ textAlign: "right" }}
                            >
                                <Button
                                    disabled={mfaLoading}
                                    onClick={this.handleMfaSubmit}
                                    variant="contained"
                                    color="primary"
                                >
                                    Log In {mfaLoading && <CircularProgress size={20} style={{ position: "absolute" }} />}
                                </Button>
                            </Grid>

                        </Grid>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}
LoginPage.displayName = "LoginPage";
LoginPage = connect((state) => ({ authState: state.auth, dashboardPermissions: getdashboardPermissions(state) }), {
    ...authActions,
    ...navActions,
})(LoginPage);

export default withStyles(styles)(withRouter(LoginPage));
